import React from 'react';
import { GiftIcon, AlertCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  num: '1',
  title: 'Checklist de Compras de 10 Minutos',
  desc: 'Domina el supermercado. Una lista exacta de qué comprar (y qué evitar) para sanar tu tiroides sin perder horas leyendo etiquetas.'
}, {
  num: '2',
  title: 'Guía de Sustitutos de Emergencia (Ahorro)',
  desc: 'No gastes en harinas caras. Aprende a sustituir ingredientes costosos por opciones locales y baratas que funcionan igual o mejor.'
}, {
  num: '3',
  title: 'Planificador Batch Cooking "Cero Agotamiento"',
  desc: 'El mapa para cocinar solo un par de horas y tener resuelta toda tu semana. Ideal para días de fatiga extrema.'
}, {
  num: '4',
  title: 'Manual de Elixires y Bebidas Express',
  desc: 'Preparaciones rápidas para drenar la hinchazón mañanera y activar tu metabolismo en ayunas.'
}, {
  num: '5',
  title: 'Diario de Síntomas y Progreso',
  desc: 'Rastrea cómo recuperas tu energía día tras día y conviértete en la experta de tu propio cuerpo.'
}, {
  num: '6',
  title: 'Guía de Cenas Ligeras para Dormir Mejor',
  desc: 'Recetas específicas para mejorar la calidad de tu sueño, factor clave para la regeneración de tu tiroides.'
}];
export function BonusSection() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-18">
      <div className="max-w-2xl mx-auto" data-id="element-19">
        <div className="text-center mb-6 flex flex-col items-center" data-id="element-20">
          <div className="bg-brand-lime/10 p-3 rounded-lg mb-3" data-id="element-21">
            <GiftIcon className="w-7 h-7 text-brand-lime" data-id="element-22" />
          </div>
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-forest mb-2 leading-tight" data-id="element-23">
            Si ordenas hoy el Protocolo Maestro, te llevas estos 6 complementos
            de forma totalmente GRATUITA:
          </h2>
        </div>

        <div className="space-y-3 mb-6" data-id="element-24">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-border p-4 rounded-lg" data-id="element-25">
              <div className="flex items-center gap-2 mb-2" data-id="element-26">
                <span className="text-brand-lime font-bold text-xs tracking-wide" data-id="element-27">
                  🎁 BONUS {bonus.num}
                </span>
                <span className="text-brand-muted/40" data-id="element-28">|</span>
                <span className="text-xs font-bold text-brand-orange uppercase" data-id="element-29">
                  GRATIS
                </span>
              </div>
              <h3 className="text-sm sm:text-base font-bold text-brand-forest leading-tight mb-1" data-id="element-30">
                {bonus.title}
              </h3>
              <p className="text-xs sm:text-sm text-brand-muted leading-snug" data-id="element-31">
                {bonus.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-orange/10 border border-brand-orange/30 rounded-lg p-4 flex gap-3 items-start mb-6" data-id="element-32">
          <AlertCircleIcon className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-33" />
          <p className="text-xs sm:text-sm leading-snug text-brand-text" data-id="element-34">
            <strong className="uppercase text-brand-orange" data-id="element-35">
              ⚠️ Importante:
            </strong>{' '}
            Esta oferta con los 6 Bonos Gratis y el descuento masivo está
            disponible solo para los próximos{' '}
            <strong className="text-brand-orange" data-id="element-36">500 cupos</strong> o hasta que
            el contador llegue a cero.
          </p>
        </div>

        <div className="text-center" data-id="element-37">
          <p className="text-sm font-bold text-brand-forest mb-3" data-id="element-38">
            No pierdas la oportunidad de transformar tu salud al precio de una
            cena.
          </p>
          <CTAButton variant="primary" className="max-w-md mx-auto" data-id="element-39">
            SÍ, QUIERO MIS 6 BONOS GRATIS AHORA 🌿
          </CTAButton>
        </div>
      </div>
    </section>;
}